import { Modal } from 'antd';
import React, { useState } from 'react';
import Spinner from './Spinner';
import TicIcon from '../Assets/Icons/TicIcon';
import CrossIcon from '../Assets/Icons/CrossIcon';

function ConfirmaModal({ title, content, okText = 'OK', cancelText = 'No, cancel', onOk, loading, ...props }) {
  return (
    <Modal //
      footer={false}
      title={false}
      className="max-w-[520px] w-full"
      width="100%"
      {...props}>
      <div className="py-[12px] px-[8px]">
        <h5 className="text-xl leading-[12px] font-semibold">{title}</h5>
        <p className="mt-3 text-gray-700">{content}</p>
        <div className="flex items-center justify-between flex-wrap">
          <button
            disabled={loading}
            onClick={onOk}
            className={`relative flex items-center justify-center mt-6 rounded-xl py-4 ${
              loading ? 'bg-[#2a9134]' : 'bg-[#EEF2F0] '
            }   text-black hover:bg-[#2a9134] hover:text-white border-[1px] leading-[8px] outline-none border-[#EEF2F0] font-semibold sm:w-[calc(50%-8px)] w-full `}>
            {loading ? <Spinner /> : null}
            <div
              className={loading ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'}>
              <TicIcon className="mr-[12.12px]" stroke="currentColor" />
              {okText}
            </div>
          </button>
          <button
            onClick={props.onCancel}
            className="flex items-center justify-center mt-6 rounded-xl py-4 bg-[#EEF2F0]  text-black hover:bg-[#2a9134]  hover:text-white border-[1px] leading-[8px] outline-none border-[#EEF2F0] font-semibold sm:w-[calc(50%-8px)] w-full">
            <CrossIcon className="mr-[11.89px]" stroke="currentColor" />
            {cancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmaModal;
